import {ToastType} from "@/pcm/types/interfaces/ToastType";
import {useBus} from "@/pcm/plugins/helper";

const toast = (type: ToastType, message: string, time: number = 10) => {
    useBus().emit('toast', {
        type: type,
        message: message,
        time: time,
    });
};

export default {
    install: (app: any) => {
        app.config.globalProperties.$toast = toast;
    }
}

export {
    toast
}
